import React, { useEffect, useState } from 'react'
import PageTitleBanner from './Common/PageTitleBanner';
import { Document, Page, pdfjs } from 'react-pdf';
import { NOTEBOOKURL } from '../Config';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const CorporateBrochure = () => {
  const [mainContent, setMainContent] = useState([])
  useEffect(() => {
    getContactData()
  }, [])
  const getContactData = async () => {
    const res = await fetch(`${NOTEBOOKURL}Corporate/GetCorporate`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        CorporateDetailID: "",
        CorporateType: "",
        StartDate: "",
        EndDate: "",
        PaginationID: "-1",
        PageLength: ""
      }),
    });
    const result = await res.json();
    console.log(result, "result");
    const filterData = result.data.filter((item, index) => {
      return item.CorporateType == "Brochure"
    })
    console.log(filterData, "filterData")
    setMainContent(filterData)


  };
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const pdfUrl = process.env.REACT_APP_Corporate + mainContent[0]?.PDF
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <>
      <PageTitleBanner title={"Corporate Brochure"} />
      <div id="content" className="site-content">
        <div className="container">
          <div className="row">
            <div id="primary" className="content-area" style={{ float: 'none' }}>
              <div className="site-main">
                <div className='col-md-12'>
                  <h2 style={{ position: "relative" }} className="single-project-title">{mainContent[0]?.Title}</h2>
                </div>

                <div className='col-md-6'>
                  <blockquote style={{ paddingTop: "20px", textAlign: "justify" }}>{mainContent[0]?.Description}</blockquote>
                </div>

                <div className='col-md-6'>
                  <div style={{ overflow: "auto", maxHeight: "550px" }} className="project-content">
                    {/* <Document
                      file={pdfUrl}
                      onLoadSuccess={onDocumentLoadSuccess}
                      onLoadError={console.error}
                      className="pdf-document"
                    >
                      <Page pageNumber={numPages} />
                    </Document> */}

                    {mainContent[0]?.PDF &&
                      <iframe src={process.env.REACT_APP_Corporate + mainContent[0].PDF} style={{ height: '500px', width: '100%', border: 'none' }} />
                    }

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CorporateBrochure